<template>
  <FlexboxLayout :class="classes" flexWrap="wrap">
    <slot name="default" />
  </FlexboxLayout>
</template>

<script>

export default {
  props: {
    altOrder: {
      type: Boolean,
      default: false
    },
    navButtons: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes (){
      return {
        'button-set': true,
        'alt-order': this.altOrder,
        'nav-buttons': this.navButtons
      }
    }
  }
}

</script>

<style scoped lang="scss">

.button-set::v-deep .button {
  width: 100%;
}

.ns-ios,
.ns-android {
  .button-set {
    padding-top: 0;
  }

  .button-set::v-deep .button {
    margin-top: 20;
  }
}

html {
  .button-set::v-deep .button {
    margin-top: 20px;
  }

  @media (min-width: 600px) {
    .button-set.alt-order {
      flex-direction: row-reverse;
    }

    .button-set::v-deep .button {
      width: 40%;
      flex-grow: 1;
      margin: 20px 10px 0 10px;
    }

    .button-set::v-deep .button:nth-child(odd) {
      margin-left: 0;
    }

    .button-set.alt-order::v-deep .button:nth-child(odd) {
      margin-left: 10px;
      margin-right: 0;
    }

    .button-set::v-deep .button:last-child:nth-child(odd) {
      margin-left: 0;
      margin-right: 0;
    }

    .button-set::v-deep .button:nth-child(even) {
      margin-right: 0;
    }

    .button-set.alt-order::v-deep .button:nth-child(even) {
      margin-left: 0;
      margin-right: 10px;
    }

    /* Navigation buttons styling - right aligned with auto width */
    .button-set.nav-buttons {
      width: 100% !important;
      text-align: right !important;
      display: block !important;
      direction: rtl !important;
    }

    .button-set.nav-buttons::v-deep .button {
      width: auto !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      vertical-align: top !important;
      // margin: 20px 16px 0 0 !important;
      padding: 12px 18px !important;
      height: auto !important;
      min-height: auto !important;
      text-align: center !important;
      direction: ltr !important;
      box-sizing: border-box !important;
      line-height: 1 !important;
      margin-bottom: 20px;
    }

    .button-set.nav-buttons::v-deep .button:last-child {
      margin-right: 0 !important;
    }

    .button-set.nav-buttons::v-deep .button .text {
      line-height: 16px !important;
      font-size: 16px !important;
      text-align: center !important;
      vertical-align: middle !important;
      margin: 0 !important;
      padding: 0 !important;
      height: 16px !important;
      display: block !important;
    }

    .button-set.nav-buttons.alt-order::v-deep .button:first-child {
      margin-left: 16px !important;
    }

    .button-set.nav-buttons.alt-order::v-deep .button:last-child {
      margin-left: auto !important;
    }
  }
}

</style>